import { wsUrl } from "./config";

let ws = null;
let token = null;
let retryTimer = null;
let pingTimer = null;
const channels = new Set();
const listeners = new Map();

function open() {
  if (!token) return;
  if (ws && ws.readyState !== 2 && ws.readyState !== 3) ws.close();
  const sock = new WebSocket(wsUrl(token));
  ws = sock;
  sock.onopen = () => {
    channels.forEach((ch) => sock.send(JSON.stringify({ type: "subscribe", channel: ch })));
    pingTimer = setInterval(() => {
      if (sock.readyState === 1) sock.send(JSON.stringify({ type: "ping" }));
    }, 25000);
  };
  sock.onmessage = (e) => {
    try {
      const ev = JSON.parse(e.data);
      (listeners.get(ev.type) || []).forEach((cb) => cb(ev));
    } catch {}
  };
  sock.onclose = () => {
    clearInterval(pingTimer);
    if (token && ws === sock) retryTimer = setTimeout(open, 3000);
  };
}

export const connectSocket = (t) => {
  if (token === t && ws && (ws.readyState === 0 || ws.readyState === 1)) return;
  token = t;
  clearTimeout(retryTimer);
  open();
};

export const disconnectSocket = () => {
  token = null;
  clearTimeout(retryTimer);
  const sock = ws;
  ws = null;
  if (sock) sock.close();
  channels.clear();
};

export const subscribe = (ch) => {
  channels.add(ch);
  if (ws && ws.readyState === 1) ws.send(JSON.stringify({ type: "subscribe", channel: ch }));
};

export const unsubscribe = (ch) => {
  channels.delete(ch);
  if (ws && ws.readyState === 1) ws.send(JSON.stringify({ type: "unsubscribe", channel: ch }));
};

export const onEvent = (type, cb) => {
  const arr = listeners.get(type) || [];
  arr.push(cb);
  listeners.set(type, arr);
  return () => listeners.set(type, (listeners.get(type) || []).filter((f) => f !== cb));
};

export const sendTyping = (conversationId, isTyping) => {
  if (ws && ws.readyState === 1)
    ws.send(JSON.stringify({ type: "typing", channel: `dm:${conversationId}`, conversationId, isTyping }));
};
